import React, {Component} from 'react';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {Modal, Input, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {dateFormatPicker, noTimeZoneFullISODate} from '../../../common/constants/datesFormat';

class PortArrivalEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {'selectedDate': ''};
    this.handleClose = this.handleClose.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleUpdateClick = this.handleUpdateClick.bind(this);
  }

  handleDateChange(value) {
    this.setState({'selectedDate': moment(value).format(noTimeZoneFullISODate)});
  }

  handleUpdateClick() {
    const {invoice, filters} = this.props;

    this.props.updateInvoicePortArrivalDate(invoice.code, this.state.selectedDate, filters.status);
    this.handleClose();
  }

  handleClose() {
    this.setState({'selectedDate': ''});
    this.props.closeHandler();
  }

  render() {
    const {selectedDate} = this.state;
    const {isOpen, invoice} = this.props;
    const {code, portArrivalDate} = invoice || {};
    const arrivalDate = selectedDate || portArrivalDate;

    return (
      <Modal
        size='mini'
        open={isOpen}
        closeOnDimmerClick={false}
        onClose={this.handleClose}
        trigger={<span/>}
      >
        <Modal.Header>Edición ETA Puerto - {code}</Modal.Header>
        <Modal.Content>
          <DatePicker
            locale='es'
            customInput={<Input fluid icon='calendar' />}
            dateFormat={dateFormatPicker}
            selected={arrivalDate ? moment(arrivalDate).toDate() : null}
            onChange={this.handleDateChange}

          />
        </Modal.Content>
        <Modal.Actions>
          <Button secondary content='CANCELAR' onClick={this.handleClose} />
          <Button primary disabled={!selectedDate} content='ACTUALIZAR' onClick={this.handleUpdateClick} />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'invoice': state.providersImportations.selectedInvoice,
    'filters': state.providersImportations.filters,
  };
};

const {
  updateInvoicePortArrivalDate,
} = Actions;

export default connect(mapStateToProps, {
  updateInvoicePortArrivalDate,
})(PortArrivalEditor);
